import React from "react";

import LayerPanel from "fond/project/panels/InputPanel/LayerPanel";

import { useDesignRefinementActions } from "../hooks/useDesignRefinementActions";

/**
 * Stacked navigation panel for editing the drop assignments of a completed design.
 */
const DropAssignmentsRefinementPanel: React.FC = () => {
  const { editDropAssignments } = useDesignRefinementActions();

  return (
    <LayerPanel
      title="Drop assignments"
      layerKey="design-drop-assignments"
      actions={["draw"]}
      drawSubtitle="Edit drop assignments on the map"
      onDraw={editDropAssignments}
    />
  );
};

export default DropAssignmentsRefinementPanel;
